import React, {useContext, useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { getLastMeasurementId } from "../helpers/ApiRequests";
import {KeycloakContext} from "../context/KeycloakContext";
import Patient from "./Patient/Patient";

// Definición de un componente funcional
const LastReading = () => {
    const { t, i18n } = useTranslation();
    const { kc } = useContext( KeycloakContext )
    const [ patientId, setPatientId ] = useState(null)

    const getLastMeasurement = async () => {
        if (kc && kc.token) {

            // Build query parameters for filters
            const params = new URLSearchParams();
            params.append('page', 1);
            params.append('size', 1);
            const response = await getLastMeasurementId(kc, params)
            if (response) {
                setPatientId(response.messungen[0].id)
            }
        }
    };
    useEffect(() => {
        getLastMeasurement();
    }, []);
    return (
        <div className=''>
            {patientId && (
                <Patient id={patientId}  isLastReading={true}/>
            )}

        </div>
    );
}

export default LastReading;
